import * as React from "react";
import FocusLock from "react-focus-lock";
import { Portal } from "react-portal";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { create } from "zustand";
import styles from "./SlowAction.module.less";

const store = create<{ state: [boolean, string?] }>(() => ({ state: [false] }));
export const SHOW_SLOWACTION = "SHOW_SLOWACTION";
export const HIDE_SLOWACTION = "HIDE_SLOWACTION";
export const UPDATE_SLOWACTION = "UPDATE_SLOWACTION";

export const show = (text?: string): void => {
  store.setState((prevState) => ({ state: [true, text ?? prevState.state[1]] }));
};

export const hide = (): void => {
  store.setState((prevState) => ({ state: [false, prevState.state[1]] }));
};

export const updateText = (text: string): void => {
  store.setState((prevState) => ({ state: [prevState.state[0], text] }));
};

type SlowAction = {
  defaultText?: string;
  focusTrap?: boolean;
  className?: string;
};

const SlowAction: React.FC<SlowAction> = ({ defaultText = "Vennligst vent...", focusTrap = true, className }) => {
  const [enabled, text] = store((state) => state.state);

  React.useEffect(() => {
    updateText(defaultText);
  }, [defaultText]);

  const slowActionClass = cls(
    {
      [styles.slowAction]: true,
    },
    className
  );

  let content = (
    <div className={slowActionClass} role="presentation" tabIndex={-1}>
      <div className={styles.slowActionLoader} />
      <div
        role="status"
        aria-live="polite"
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        className={styles.slowActionText}
      >
        {text}
      </div>
    </div>
  );
  if (focusTrap) {
    content = <FocusLock returnFocus={false}>{content}</FocusLock>;
  }
  return enabled ? <Portal node={document && document.getElementById("app")}>{content}</Portal> : null;
};

export default SlowAction;
